import { Action, Reducer } from 'redux';
import { fork, call, takeEvery, put, all, select, delay } from 'redux-saga/effects';

import PhoneNumberType from 'src/models/PhoneNumberType';

import Api from '../api';

import { actionCreators as layoutActionCreators } from '../reducers/Layout';
import { selectors as authSelectors } from '../reducers/Auth';

import { IRootState } from './index';

// Store
export interface IPhoneNumberTypeState {
    isLoadingPhoneNumberTypes: boolean;
    phoneNumberTypes: Array<PhoneNumberType>;
}

const initialState: IPhoneNumberTypeState = {
    isLoadingPhoneNumberTypes: false,
    phoneNumberTypes: undefined,
};

// Action Types
export enum actionTypes {
    GET_PHONE_NUMBER_TYPES = '[phoneNumberType] GET_PHONE_NUMBER_TYPES',
    GET_PHONE_NUMBER_TYPES_SUCCESS = '[phoneNumberType] GET_PHONE_NUMBER_TYPES_SUCCESS',
}

// Action Creator
export const actionCreators = {
    getPhoneNumberTypes: () => {
        return { type: actionTypes.GET_PHONE_NUMBER_TYPES };
    },
    getPhoneNumberTypesSuccess: (phoneNumberTypes: Array<PhoneNumberType>) => {
        return { type: actionTypes.GET_PHONE_NUMBER_TYPES_SUCCESS, payload: phoneNumberTypes };
    },
};

// Reducer
const reducer: Reducer<IPhoneNumberTypeState> = (state: IPhoneNumberTypeState = initialState, action: Action): IPhoneNumberTypeState => {
    switch (action.type) {
        case actionTypes.GET_PHONE_NUMBER_TYPES:
            return {
                ...state,
                isLoadingPhoneNumberTypes: true,
            };
        case actionTypes.GET_PHONE_NUMBER_TYPES_SUCCESS:
            const getPhoneNumberTypesPayload = (action as { type: string; payload: Array<PhoneNumberType> }).payload;
            return {
                ...state,
                phoneNumberTypes: getPhoneNumberTypesPayload,
                isLoadingPhoneNumberTypes: false,
            };
        default:
            return state;
    }
};

export default reducer;

const phoneNumberTypeSelector = (state: IRootState): Array<PhoneNumberType> => state.phoneNumberType.phoneNumberTypes;

export const selectors = {
    phoneNumberTypes: phoneNumberTypeSelector,
};

// Side-Effects
const sagas = {
    getPhoneNumberTypes: function* (): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const [result] = yield all([call(Api.PhoneNumberType.getAll, jwt), delay(200)]);
        yield put(actionCreators.getPhoneNumberTypesSuccess(result));
    },
};

const watches = {
    getPhoneNumberTypes: function* () {
        yield takeEvery(actionTypes.GET_PHONE_NUMBER_TYPES, sagas.getPhoneNumberTypes);
    },
};

export function* saga() {
    yield fork(watches.getPhoneNumberTypes);
}



// WEBPACK FOOTER //
// ./src/reducers/PhoneNumberType.ts